import React, { useState } from "react";
import ContributeButton from "@/components/pages/Community/ContributeButton";
import PanelSeparator from "@/components/pages/Community/PanelSeparator";

import { Stack, Box, Collapse } from "@mui/material";
import ContributePanelOptionRender from "../ContributePanelOptionRender";
import CodeAndDocumentation from "../CodeAndDocumentation";

const NavButtons = ({ contributePanel }) => {
  const [panel, setPanel] = useState(null);

  const RenderComponent = ({ name, items }) => {
    switch (name) {
      case "CodeAndDocumentation":
        return <CodeAndDocumentation items={items} />;
    }
    return <ContributePanelOptionRender items={items} />;
  };

  return (
    <>
      <Stack
        gap={3}
        useFlexGap
        direction="row"
        flexWrap="wrap"
        justifyContent={{ xs: "center", md: "flex-start" }}
        alignItems="flex-start"
        sx={{ marginBottom: 6 }}
      >
        {contributePanel.navButtons.map(
          ({ image, title, imageAlt, externalURL }, index) => (
            <ContributeButton
              key={`contributePanel-${title}`}
              onClick={() => setPanel((i) => (i === index ? null : index))}
              active={panel === index}
              image={image.publicURL}
              title={title}
              imageAlt={imageAlt}
              externalURL={externalURL ?? null}
            />
          )
        )}
      </Stack>
      <Collapse in={panel !== null}>
        <Box sx={{ padding: { xs: 0, md: 3 }, margin: 0 }}>
          {contributePanel.navButtons.map((navButton, index) => (
            <Collapse
              in={panel === index}
              sx={{ margin: 0, padding: 0 }}
              key={`navButtonPanel-${navButton.title}`}
            >
              <PanelSeparator />
              <RenderComponent
                name={navButton.component}
                items={navButton.items}
              />
            </Collapse>
          ))}
        </Box>
      </Collapse>
    </>
  );
};

export default NavButtons;
